import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './ProductsPmsHeader.css';

function ProductProstayPayHeader() {
    const { t } = useTranslation();

    return (
        <div className='product-header' style={{ backgroundImage: 'url(/images/prostay-pay-header.png)' }}>
            <div className='page-content d-flex align-items-center'>
                <div className='col-6 d-flex flex-column'>
                    <div className='chip-red'>

                         {t('Prostay Payments')}
                    </div>
                    <h1>{t('Hotel Payment Processing Reimagined - Secure, Automated, Seamless with Prostay Pay')}</h1>
                    <p className='body-large'>
                        {t('Simplify hotel payments with Prostay Pay.')} <br/>
                        {t('Automate payment collection, send secure links, and connect with your PMS. Built for the hospitality industry and fully integrated with all Prostay modules.')}
                    </p>
                </div>
                <div className='col img-wrapper'>
                    <img src='/images/prostay-pay-header-img.svg' alt={"Room planning"}/>
                </div>
            </div>
        </div>
    );
}

export default ProductProstayPayHeader;
